<template>
  <el-table-column
    prop="min_stock"
    sortable="custom"
    label="Kritikus készlet"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.min_stock || 0 }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'min_stock',
  };
</script>
